import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=94138992&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/detail.scss?vue&type=style&index=0&id=94138992&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94138992",
  null
  
)

export default component.exports